// /** Vue Components */

/** Dashboard */
Vue.component(
    "dashboard",
    require("./components/dashboard/details-ui.vue").default
);

/** Products */
Vue.component(
    "product-list",
    require("./components/products/product-list.vue").default
);
Vue.component("select2", require("./components/select2.vue").default);
Vue.component(
    "product-details",
    require("./components/products/details-ui.vue").default
);

/** Projects */
Vue.component(
    "projects-listing",
    require("./components/projects/projects-listing.vue").default
);
Vue.component(
    "project-products-listing",
    require("./components/projects/project-products-listing.vue").default
);
Vue.component(
    "add-project-products",
    require("./components/projects/add-project-products.vue").default
);
Vue.component(
    "create-project-form",
    require("./components/projects/create-project-form.vue").default
);

/** Workflows */
Vue.component(
    "workflows-listing",
    require("./components/workflows/workflows-listing.vue").default
);

Vue.component(
    "workflows-index",
    require("./components/workflows/workflows-index.vue").default
);

Vue.component(
    "edit-workflow",
    require("./components/workflows/edit-workflow.vue").default
);

Vue.component(
    "workflow-projects-listing",
    require("./components/workflows/workflow-projects-listing.vue").default
);

Vue.component(
    "create-workflow-form",
    require("./components/workflows/create-workflow-form.vue").default
);

Vue.component(
    "workflow-restrict-user",
    require("./components/workflows/workflow-restrict-user.vue").default
);

/** Categories */
Vue.component(
    "category-form",
    require("./components/categories/category-form.vue").default
);
Vue.component(
    "categories-tree",
    require("./components/categories/categories-tree.vue").default
);

/** DAM */
Vue.component(
    "dam-products",
    require("./components/dam/products.vue").default
);
Vue.component(
    "dam-folder-list",
    require("./components/dam/folder-list.vue").default
);
Vue.component(
    "dam-asset-list",
    require("./components/dam/asset-list.vue").default
);
Vue.component(
    "asset-list-table",
    require("./components/dam/asset-list-table.vue").default
);
Vue.component(
    "lightbox",
    require("./components/dam/lightbox.vue").default
);
Vue.component("dam-folder", require("./components/dam/folder.vue").default);
Vue.component("dam-asset", require("./components/dam/asset.vue").default);

/*
 * !!!@TODO: Organize.
 */
Vue.component(
    "price-rule-entity-selector",
    require("./components/pricerules/entity-selector.vue").default
);
Vue.component(
    "effective-price-breakdown",
    require("./components/pricerules/effective-price-breakdown.vue").default
);
Vue.component(
    "create-product-wizard",
    require("./components/products/create-product-wizard.vue").default
);
Vue.component(
    "attribute-display-groups",
    require("./components/attributes/display-groups.vue").default
);
Vue.component(
    "modal-listing-of-deleted-items",
    require("./components/tables/modal-deletion-list.vue").default
);
Vue.component(
    "workflow-required-attributes",
    require("./components/attributes/workflow-required-attributes.vue").default
);
Vue.component(
    "channels-create",
    require("./components/channels/create.vue").default
);
Vue.component(
    "onboarding-wizard",
    require("./components/channels/onboarding-wizard.vue").default
);
Vue.component(
    "scheduled-content-changes",
    require("./components/scheduled-content-changes/scheduled-content-changes.vue")
        .default
);
Vue.component(
    "activity-log-listing",
    require("./components/tables/activity-log-listing.vue").default
);
Vue.component(
    "communication-logs-listing",
    require("./components/tables/communication-logs-listing.vue").default
);
Vue.component(
    "category-grid-listing",
    require("./components/tables/category-grid-listing.vue").default
);
Vue.component(
    "attribute-sets-listing",
    require("./components/tables/attribute-sets-listing.vue").default
);
Vue.component(
    "attributes-listing",
    require("./components/tables/attributes-listing.vue").default
);
Vue.component(
    "option-set-listing",
    require("./components/tables/option-set-listing.vue").default
);
Vue.component(
    "option-listing",
    require("./components/tables/option-listing.vue").default
);
Vue.component(
    "brand-listing",
    require("./components/tables/brand-listing.vue").default
);
Vue.component(
    "web-content-static-listing",
    require("./components/tables/web-content-static-listing.vue").default
);
Vue.component(
    "web-content-page-listing",
    require("./components/tables/web-content-page-listing.vue").default
);
Vue.component(
    "template-listing",
    require("./components/tables/template-listing.vue").default
);
Vue.component(
    "currency-listing",
    require("./components/tables/currency-listing.vue").default
);
Vue.component(
    "channels-listing",
    require("./components/tables/channels-listing.vue").default
);
Vue.component(
    "users-listing",
    require("./components/tables/users-listing.vue").default
);
Vue.component(
    "roles-listing",
    require("./components/tables/roles-listing.vue").default
);
Vue.component(
    "language-listing",
    require("./components/tables/language-listing.vue").default
);
Vue.component(
    "price-vendor-penalties",
    require("./components/tables/price-vendor-penalties.vue").default
);
Vue.component(
    "price-rule-sets",
    require("./components/tables/price-rule-sets.vue").default
);
Vue.component(
    "price-rule-set-show",
    require("./components/tables/price-rule-set-show.vue").default
);
Vue.component(
    "price-rule-show",
    require("./components/tables/price-rule-show.vue").default
);
Vue.component(
    "product-matching-listing",
    require("./components/tables/product-matching-listing.vue").default
);
Vue.component(
    "generic-entity-listing",
    require("./components/tables/generic-entity-listing.vue").default
);
Vue.component(
    "product-related-types-listing",
    require("./components/tables/product-related-types-listing.vue").default
);
Vue.component(
    "api-keys-listing",
    require("./components/tables/api-keys-listing.vue").default
);
Vue.component(
    "data-schema-listing",
    require("./components/tables/data-schema-listing.vue").default
);
Vue.component(
    "entity-related-types-listing",
    require("./components/tables/entity-related-types-listing.vue").default
);
Vue.component(
    "pagination-report-listing",
    require("./components/tables/pagination-report-listing.vue").default
);
Vue.component(
    "generic-entity-option-tree-listing",
    require("./components/generic/tree-listing.vue").default
);
Vue.component(
    "generic-entity-option-listing",
    require("./components/tables/generic-options-listing.vue").default
);
Vue.component(
    "exports-index",
    require("./components/exports/exports-index.vue").default
);
Vue.component(
    "export-profiles-index",
    require("./components/exports/export-profiles-index.vue").default
);
Vue.component(
    "export-generic-entities-index",
    require("./components/exports/export-generic-entities-index.vue").default
);
Vue.component(
    "export-product-brands-index",
    require("./components/exports/export-product-brands-index.vue").default
);
Vue.component(
    "export-product-attribute-values-versions-index",
    require("./components/exports/export-product-attribute-values-versions-index.vue").default
);
Vue.component(
    "export-sku-tags",
    require("./components/exports/export-sku-tags.vue").default
);
Vue.component(
    "input-email-wizard",
    require("./components/exports/input-email-wizard.vue").default
);
Vue.component(
    "imports-index",
    require("./components/imports/imports-index.vue").default
);
Vue.component(
    "import-generic-entities-index",
    require("./components/imports/import-generic-entities-index.vue").default
);
Vue.component(
    "import-products-index",
    require("./components/imports/import-products-index.vue").default
);
Vue.component(
    "jobs-index",
    require("./components/jobs/jobs-index.vue").default
);
Vue.component(
    "jobs-details",
    require("./components/jobs/job-details.vue").default
);
Vue.component(
    "config-builder",
    require("./components/profile-builder/config-builder.vue").default
);
Vue.component(
    "fields-list",
    require("./components/profile-builder/fields-list.vue").default
);
Vue.component(
    "channel-connect",
    require("./components/channels/connect.vue").default
);
Vue.component(
    "quick-help",
    require("./components/generic/quick-help.vue").default
);
Vue.component(
    "edit-options",
    require("./components/options/edit-options.vue").default
);
Vue.component(
    "edit-attributes",
    require("./components/attributes/edit-attributes.vue").default
);
Vue.component(
    "edit-property-header-block",
    require("./components/generic/edit-property-header-block.vue").default
);
Vue.component(
    "activity-log-generic",
    require("./components/activity/activity.vue").default
);
Vue.component(
    "product-advanced-search",
    require("./components/products/advanced-search/advanced-search.vue").default
);

/** Pricing Profiles */
Vue.component(
    "pricing-profiles-listing",
    require("./components/pricing-profiles/pricing-profiles-listing.vue").default
);
Vue.component(
    "pricing-profile-form",
    require("./components/pricing-profiles/pricing-profile-form.vue").default
);

/** Scheduled imports */
Vue.component(
    "scheduled-imports-index",
    require("./components/scheduled-imports/scheduled-imports-index.vue").default
);

Vue.component(
    "import-related-product-attributes-index",
    require("./components/imports/import-related-product-attributes-index.vue").default
);
Vue.component(
    "webhook-listing",
    require("./components/tables/webhook-listing.vue").default
);
